import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  Switch,
  ChannelLayoutEditor,
  SelectChannelLayoutPreset,
} from "signoxe/components/widgets";
import {
  setPageTitle,
  fetchChannels,
  addChannel,
  updateChannel,
  saveRegionFile,
  addUserReport,
} from "signoxe/actions";
import { Page, EditableLabel } from "signoxe/components";
import {
  getChannel,
  getPlaylistsV2,
  getTickerSeriesList,
  getTickerSeries,
  playlistItemsFromIds,
  getProfile,
  getFeatureStatus,
} from "signoxe/selectors";
import { API_ROOT } from "signoxe/constants/config";
import Box from "signoxe/components/layout/Box";
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from "react-simple-dropdown";
import "./styles.scss";
import SelectSearch from "signoxe/components/widgets/SelectSearch";

class ChannelPage extends React.Component {
  static propTypes = {
    fetchChannels: PropTypes.func.isRequired,
    addUserReport: PropTypes.func.isRequired,
    addChannel: PropTypes.func.isRequired,
    updateChannel: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    channel: PropTypes.object,
    ticker: PropTypes.object,
    playlists: PropTypes.array.isRequired,
    tickerSeriesOptions: PropTypes.array.isRequired,
    profile: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      regions: [],
      updating: false,
      editRegionsMode: true,
      aspectRatio: "LANDSCAPE",
      tickerIndex: 0,
      behaviours: [],
      rows:null,
      cols:null,
      reportActivityStatus:
        this.props.profile &&
        this.props.profile.features &&
        this.props.profile.features.record_user_activity,
    };
    this.layoutEditorRef = null;
  }

  componentDidMount() {
    this.props.fetchChannels();
    this.props.setPageTitle("Channel");

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    fetch(`${API_ROOT}region_behaviour/`, requestOptions)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((obj) => {
        if (obj) {
          this.setState({ ...this.state, behaviours: obj });
        }
      });
  }

  componentWillReceiveProps(nextProps) {
    let stateData = {};
    if (
      !_.isEqual(nextProps.channel, this.props.channel) ||
      (this.state.regions.length == 0 &&
        !_.isEmpty(_.get(nextProps, ["channel", "regions"])))
    ) {
      stateData = { ...stateData, regions: nextProps.channel.regions,  };
    }

    if (
      nextProps.channel &&
      nextProps.channel.aspect_ratio !== this.state.aspectRatio
    ) {
      stateData = { ...stateData, aspectRatio: nextProps.channel.aspect_ratio };
    }

    if (
      nextProps.channel && this.state.cols === null &&
      nextProps.channel.gridY !== this.state.cols
    ) {
      stateData = { ...stateData, cols: nextProps.channel.gridY };
    }
    
    if (
      nextProps.channel && this.state.rows === null &&
      nextProps.channel.gridX !== this.state.rows
    ) {
      stateData = { ...stateData, rows: nextProps.channel.gridX };
    }

    if (!_.isEmpty(stateData)) {
      // Server contains empty region. Don't use regions from server.
      // Local regions is not empty. Don't use region from server.
      if (
        (stateData.regions && stateData.regions.length < 1) ||
        (this.state.regions && this.state.regions.length > 0)
      ) {
        delete stateData.regions;
      }
      this.setState(stateData);

    }
  }
  handleUserReport = (message) => {
    const { profile } = this.props;
    if (this.state.reportActivityStatus) {
      this.props.addUserReport({
        user: profile.id,
        action_type: "Update",
        activity: message + "Channel - " + this.props.channel.name,
      });
    }
  };

  handleSaveChannel = () => {
    this.setState({ updating: true })
    this.props.updateChannel(this.props.channel.id, {
      ...this.props.channel,
      aspect_ratio: this.state.aspectRatio,
      gridX: this.state.rows,
      gridY: this.state.cols,
      regions: this.state.regions,
    }).then(()=>{
      this.setState({ updating: false })
    });

    for (const region of this.state.regions) {
      // console.log("Region is ", region)
      if (region.audio && region.audio.type === "audio/mpeg") {
        console.log("Region is ", region);
        this.props.saveRegionFile('audio', region.audio, region.id);
      }
      if (region.region_thumbnail) {
        console.log("Region is ", region);
        this.props.saveRegionFile('region_thumbnail', region.region_thumbnail, region.id);
      }
      if (region.folder_icon) {
        console.log("Region is ", region);
        this.props.saveRegionFile('folder_icon', region.folder_icon, region.id);
      }
    }

    // this.props.saveRegionFile(this.state.regions);
  };

  onLayoutPresetSelect(regionsDataGrid, rows, cols) {
    let nextId = 0;
    const newRegions = _.map(regionsDataGrid, (data_grid) => {
      nextId += 1;
      return {
        id: nextId,
        isPending: true,
        data_grid: data_grid,
        playlist: null,
      };
    });
    this.setState({ regions: newRegions });
    this.setState({rows : rows})
    this.setState({cols : cols})
  }

  handleRename = (name) =>
    this.props.updateChannel(this.props.channel.id, { name });
  handleChangeTicker = (ticker_series) => {
    const tickerseries = this.props.tickerSeriesOptions.find(
      (e) => e.id === 48
    );
    {
      tickerseries &&
        this.state.reportActivityStatus &&
        this.handleUserReport(
          `Set Ticker series name (${tickerseries.name})  in  `
        );
    }
    this.props.updateChannel(this.props.channel.id, { ticker_series });
  };
  handleChangeOrientation = (orientation) =>
    this.props.updateChannel(this.props.channel.id, {
      aspect_ratio: orientation,
    });

  onRegionsChange = (regions) => this.setState({ regions });

  render() {

    let layoutSize;
    const { regions, rows, cols } = this.state;
    console.log("channels details", this.props.channel )
    const {
      channel,
      playlists,
      tickerSeriesOptions,
      profile,
      regionBehaviour,
      regionSound,
    } = this.props;

    // console.log('///////////////', profile);
    // "So the screen that we present could be a 1080 x 1920 resolution." - Aspect ratio = 1.78
    if (!channel) return null;

    let tickers = [];
    if (this.props.ticker && this.props.ticker.tickers) {
      tickers = this.props.ticker.tickers;
    }
    const LayoutSizeMap = {
      LANDSCAPE: { w: 800, h: 450 },
      REVERSE_LANDSCAPE: { w: 800, h: 450 },
      PORTRAIT: { w: 450, h: 800 },
      REVERSE_PORTRAIT: { w: 450, h: 800 },
    };

    const mobile = {
      w: 350,
      h: 600,
    };

    if (window.innerWidth <= 550) {
      layoutSize = mobile;
    } else {
      layoutSize = LayoutSizeMap[this.state.aspectRatio];
    }

    // const layoutSize = LayoutSizeMap[this.state.aspectRatio];

    // ticker series options
    var tickerSeries_Options
    var default_tickerSeries = {label:"-- Choose -- ", value:''}
    tickerSeries_Options = [{label:"-- Choose -- ", value:''}]

    tickerSeriesOptions.map((option, index) => {
      tickerSeries_Options.push({label:option.name, value:option.id})
      if(channel.ticker_series == option.id){
        default_tickerSeries = {label:option.name, value:option.id}
      } 
    })

    return (
      <Page className="channel-page">
        <div className="flex flex-jc-sb ai-i-c">
          <h2>
            <EditableLabel value={channel.name} onChange={this.handleRename} />
          </h2>
          {this.layoutEditorRef && !_.isEmpty(regions) && (
            <React.Fragment>
              <div className="hide-for-mobile">
                <button
                  title="Save Layout"
                  disabled={
                    !this.layoutEditorRef.state.layoutIsValid ||
                    _.isEmpty(regions) ||
                    this.state.updating
                  }
                  onClick={this.handleSaveChannel}
                  className="button save-layout"
                >
                  { this.state.updating? 'Saving Layout' : 'Save Layout' }
                </button>

                <button
                  onClick={() => this.layoutEditorRef.addRegion()}
                  disabled={
                    this.props.profile != undefined?
                      this.layoutEditorRef.state.layoutIsFilled ||
                      this.state.regions.length > this.props.profile.max_region_no
                    : false
                  }
                  className="button save-layout"
                >
                  Add Region
                </button>
              </div>

              <div className="hide-for-desktop">
                <Dropdown>
                  <DropdownTrigger>
                    <button type="button" className="button">
                      <span style={{ marginRight: "5px", fontSize: "0.7rem" }}>
                        Actions
                      </span>
                      <span
                        title="actions"
                        className="icon fa fa-caret-down"
                        style={{ fontSize: "1rem", color: "#fff" }}
                      ></span>
                    </button>
                  </DropdownTrigger>
                  <DropdownContent className="user-menu actions-menu card depth-1">
                    <li>
                      <button
                        title="Save Layout"
                        disabled={
                          !this.layoutEditorRef.state.layoutIsValid ||
                          _.isEmpty(regions) ||
                          this.state.updating
                        }
                        onClick={this.handleSaveChannel}
                        className="button save-layout"
                      >
                        { this.state.updating? 'Saving Layout' : 'Save Layout' }
                      </button>
                    </li>

                    <li>
                      <button
                        onClick={() => this.layoutEditorRef.addRegion()}
                        disabled={
                          this.props.profile != undefined?
                            this.layoutEditorRef.state.layoutIsFilled ||
                            this.state.regions.length > this.props.profile.max_region_no
                          : false
                        }
                        className="button save-layout"
                      >
                        Add Region
                      </button>
                    </li>
                  </DropdownContent>
                </Dropdown>
              </div>
            </React.Fragment>
          )}
        </div>
        {this.layoutEditorRef && !_.isEmpty(regions) && (
          // <div style={{ zIndex:'1100 !important'}}>
          <div id="button-bar-Overlay">
            <Box
              direction="row"
              alignItems="baseline"
              className="pad-between left wrap-for-small buttons-bar"
            >
              <Switch
                label="Edit Regions/Set Playlist"
                formId="subscribe-feeds"
                checked={this.state.editRegionsMode}
                onChange={() =>
                  this.setState({
                    editRegionsMode: !this.state.editRegionsMode,
                  })
                }
              />
              <Box direction="row" alignItems="center" className="ticker-btn">
                <div className="switch-label">Select Ticker Series</div>
                <SelectSearch 
                  placeHolder={default_tickerSeries || ""}  
                  options={tickerSeries_Options} 
                  style={{width:`7rem`, backgroundColor:'white'}}
                  onSelect={
                      (selectedValue)=>{
                        this.handleChangeTicker(selectedValue.value)
                      } 
                  }
                  name={'ticker Series'}
                  id={'tickerSeries'}
                  multiple={false}
                />
              </Box>
            </Box>
          </div>
        )}
        {_.isEmpty(regions) && (
          <div>
            <Box
              direction="row"
              alignItems="center"
              className="grid-size-inputs"
            >
              <span className="label secondary">Aspect Ratio:</span>
              <select
                name="aspectRatio"
                className="aspectRatioSelect"
                title="Select Aspect Ratio"
                value={this.state.aspectRatio || "LANDSCAPE"}
                onChange={(e) => this.handleChangeOrientation(e.target.value)}
              >
                <option value="LANDSCAPE">Landscape</option>
                <option value="REVERSE_LANDSCAPE">Landscape Reversed</option>
                <option value="PORTRAIT">Portrait</option>
                <option value="REVERSE_PORTRAIT">Portrait Reversed</option>
              </select>
            </Box>

            <SelectChannelLayoutPreset
              profile={profile}
              onSelect={this.onLayoutPresetSelect.bind(this)}
            />
          </div>
        )}
        {!_.isEmpty(regions) && (
          <Box
            direction="row"
            justifyContent="space-between"
            className="pad-between left wrap-for-small"
          >
            <ChannelLayoutEditor
              handleUserReport={this.handleUserReport}
              reportActivityStatus={this.state.reportActivityStatus}
              regions={regions}
              profile={profile}
              regionBehaviour={regionBehaviour}
              regionSound={regionSound}
              playlists={playlists}
              onRef={(ref) => (this.layoutEditorRef = ref)}
              onRegionsChange={this.onRegionsChange.bind(this)}
              editRegionsMode={this.state.editRegionsMode}
              behaviours={this.state.behaviours}
              tickers={tickers}
              layoutHeight={layoutSize.h}
              layoutWidth={layoutSize.w}
              rows={this.state.rows}
              cols={this.state.cols}
            />
          </Box>
        )}
      </Page>
    );
  }
}

export default connect(
  (state, { match }) => {
    const props = {
      channel: getChannel(state, parseInt(match.params.id)),
      playlists: getPlaylistsV2(state),
      profile: getProfile(state),
      regionBehaviour: getFeatureStatus(state, "region_behaviour"),
      regionSound: getFeatureStatus(state, "region_sound"),
      tickerSeriesOptions: getTickerSeriesList(state),
      ticker: null,
    };

    if (props.channel && props.channel.ticker_series) {
      props.ticker = getTickerSeries(state, props.channel.ticker_series);
    }
    return props;
  },
  {
    setPageTitle,
    fetchChannels,
    addChannel,
    updateChannel,
    saveRegionFile,
    addUserReport,
  }
)(ChannelPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/ChannelPage/index.js